import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import bindActionsToDispatch from 'helpers/bindActionsToDispatch'
import navigationMenuSelector from 'redux/selectors/navigation_menu/navigation_menu_selector'
import NavigationMenuView from 'views/navigation_menu/view'

class NavigationMenu extends PureComponent {

	render() {
		return (
			<NavigationMenuView
				userImage={this.props.userImage}
				view={this.props.view}
			/>
		)
	}
}

function mapStateToProps(state) {
	return navigationMenuSelector(state)
}

function mapDispatchToProps(dispatch) {
	return bindActionsToDispatch({
	}, dispatch)
}

NavigationMenu.propTypes = {
	userImage: PropTypes.string,
	view: PropTypes.string,
}

export default connect(mapStateToProps, mapDispatchToProps)(
	NavigationMenu
)
